import { request } from '../utils/request';

const baseUrl = 'https://se-main-gqi6flraoa-uc.a.run.app/main/user/';

export function logout(competition, season, token) {
    // console.log('Games Feed service', competition, season)
    return request({
        url: baseUrl + `competition/${competition}/${season}`,
        token: token
    })
}

export function login(email, password) {
    return request({
        method: 'post',
        url: baseUrl + `login`,
        data: {
            email: email,
            password: password
        }
    })
}

export function refreshToken(refreshToken) {
    return request({
        method: 'post',
        url: baseUrl + `renew`,
        data: {
            refresh_token: refreshToken
        }
    })
}

export function passwordRecover(token, competition, season) {
    return request({
        url: baseUrl + `${competition}/${season}?format=JSON`,
        token: token
    })
}